module.exports = __webpack_public_path__ + "img/sokigo.32d7b7ca.png";